/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Auction_Date_TourInputs */

const cs_sreality_attr_auction_date_tour = /** @type {(inputs: Sreality_Attr_Auction_Date_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín 1. prohlídky`)
};

const en_sreality_attr_auction_date_tour = /** @type {(inputs: Sreality_Attr_Auction_Date_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1st Viewing Date`)
};

/**
* | output |
* | --- |
* | "1st Viewing Date" |
*
* @param {Sreality_Attr_Auction_Date_TourInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_auction_date_tour = /** @type {((inputs?: Sreality_Attr_Auction_Date_TourInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Auction_Date_TourInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_auction_date_tour(inputs)
	return cs_sreality_attr_auction_date_tour(inputs)
});